import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VueAxios from 'vue-axios'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import HandledError from './utils/handledError'
import wb from './registerServiceWorker'

Vue.prototype.$workbox = wb
Vue.config.productionTip = process.env.NODE_ENV !== 'production'

// в продакшн добиваем путь к api через axios в девелопмент через vue.config.js
if (process.env.NODE_ENV === 'production') { axios.defaults.baseURL = '/api' }

axios.interceptors.request.use(
  // Do something before request is sent
  function (config) {
    // AUTH token для запросов, если он установлен
    const token = store.state.auth.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    } else {
      config.headers.Authorization = null
      delete config.headers.Authorization
    }
    return config
  })

axios.interceptors.response.use(null,
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  function (error) {
    // 401 - не авторизован, значит токена нет
    if (error.response.status === 401) {
      router.push('/login')
      // прокидываем ошибку как обработанную
      return new Promise((resolve, reject) => { reject(new HandledError(error)) })
    }

    // Если с сервера получаем ошибку 500, с кодом, то это обрабатываемая ошибка
    if (error.response.status === 500 && error.response.data && error.response.data.errorCode) {
      // если клиент отдельно обрабатывает код ошибки, то можно его проигнорировать и не пускать на страницу /error

      // LoginOrPasswordInvalid
      if (error.response.data.errorCode === 100 ||
        // AuditAccessDenied
        error.response.data.errorCode === 110) {
        // прокидываем ошибку дальше в форму логина
        return new Promise((resolve, reject) => { reject(error) })
      }

      router.push(`/error?code=${error.response.data.errorCode}&message=${error.response.data.message}&from=${router.currentRoute.path}`)
      // прокидываем ошибку как обработанную
      return new Promise((resolve, reject) => { reject(new HandledError(error)) })
    }

    // собираем стандартную ошибку, кт. не обработал на сервере в исключениях
    const msg = error.response.status + ' ' + error.response.statusText
    router.push(`/error?message=${msg}&from=${router.currentRoute.path}`)

    // прокидываем ошибку как обработанную
    return new Promise((resolve, reject) => { reject(new HandledError(error)) })
  })

Vue.use(VueAxios, axios)
Vue.use(Vuelidate)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
